<template>
  <BrandButton
    v-if="showButton"
    class="bg-aquamarine400" v-bind="$attrs" :href="link" target="_blank"
  >
    {{ label }}
  </BrandButton>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import ms from 'ms'
import { UPDATE_NEWS_LINKS } from '@/utils/constants'

export default {
  inheritAttrs: false,
  props: {
    short: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    // Access store
    const store = useStore()
    const AppUpdatedAt = computed(() => store.getters['features/AppUpdatedAt'])

    // Access i18n
    const { t, locale } = useI18n()

    // Computed properties
    const showButton = computed(() => {
      const inputDate = AppUpdatedAt.value
      const now = new Date()

      // Calculate the difference in time
      const differenceInMs = now - inputDate

      // Convert 14 days to milliseconds
      const fourteenDaysInMs = ms('14d')

      // Check if the input date is within the past 14 days
      return differenceInMs >= 0 && differenceInMs <= fourteenDaysInMs
    })

    const label = computed(() => {
      return props.short ? t('common.update.new') : t('common.update.what_is_new')
    })

    const link = computed(() => {
      return UPDATE_NEWS_LINKS[locale.value]
    })

    return {
      showButton,
      label,
      link
    }
  }
}
</script>
